// src/components/ui/layout/AuthLayout/AuthLayout.jsx
import React from 'react';
import { cn } from '../../../../utils/cn';

const AuthLayout = ({
  children,
  className = '',
  showDecorations = true
}) => {
  return (
    <div className={cn(
      "min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900",
      "flex items-center justify-center p-6",
      className
    )}>
      {/* Background Decorative Elements */}
      {showDecorations && (
        <div className="absolute inset-0 overflow-hidden">
          {/* Top-right blue orb */}
          <div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-500/10 rounded-full blur-3xl" />
          
          {/* Bottom-left purple orb */}
          <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-purple-500/10 rounded-full blur-3xl" />
          
          {/* Center emerald orb */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-emerald-500/5 rounded-full blur-3xl" />
        </div>
      )}
      
      {/* Content Container */}
      <div className="relative w-full max-w-md">
        {children}
      </div>
    </div>
  );
};

export default AuthLayout;